import { connect, ConnectedProps } from 'react-redux';

import {
  actions as individualDashboardActions,
  selectors as individualDashboardSelectors,
} from 'src/routes/IndividualDashboard/modules/dashboard/slice';
import { apiStatusEnum } from 'src/utils/constants';
import { RootState } from 'src/redux/store';
import { UUID } from 'src/types/utility';
import { CUSTOMER_FEATURE_SETTINGS } from 'src/routes/Customers/modules/types';
import { selectors as loggedInUserSelectors } from 'src/redux/data/loggedInUser';

type OwnProps = {
  patientIdProp: UUID;
};

const mapStateToProps = (state: RootState, { patientIdProp }: OwnProps) => ({
  timezone: loggedInUserSelectors.getUserTenantTimezone(state),
  sleepData: individualDashboardSelectors.selectSleepData(state, patientIdProp),
  motionData: individualDashboardSelectors.selectMotionData(
    state,
    patientIdProp,
  ),
  patient: individualDashboardSelectors.getPatientDetails(state),
  sleepWakeSettings: individualDashboardSelectors.selectSiteFeatureSettings(
    state,
    CUSTOMER_FEATURE_SETTINGS.SLEEP_WAKE,
  ),
  hoursInBedData:
    individualDashboardSelectors.getHoursInBedData(state, patientIdProp) ?? [],
  availableFeatures:
    individualDashboardSelectors.selectAvailableFeatures(state),
  isLoading:
    individualDashboardSelectors.selectIsSleepDataLoading(
      state,
      patientIdProp,
    ) ||
    individualDashboardSelectors.selectMotionDataStatus(
      state,
      patientIdProp,
    ) === apiStatusEnum.LOADING ||
    individualDashboardSelectors.selectBedOccupancyStatus(
      state,
      patientIdProp,
    ) === apiStatusEnum.LOADING,
});

const mapActionCreators = {
  getSleepData: individualDashboardActions.getSleepData,
  getSiteFeatureSettings: individualDashboardActions.getSiteFeatureSettings,
  getMotionData: individualDashboardActions.getMotionData,
  clearSleepDataGraph: individualDashboardActions.clearSleepDataGraph,
  clearBedOccupancyGraph: individualDashboardActions.clearBedOccupancyGraph,
};
const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
